import { _ as _defineProperty } from './_chunks/dep-6108ca17.js';
import { _ as _objectWithoutProperties, r as renderFn } from './_chunks/dep-ceaccefb.js';
import Vue from 'vue';
import classNames from 'classnames';

var _excluded = ["icon", "id"],
  _excluded2 = ["staticClass", "style", "icon", "id", "onClick"],
  _excluded3 = ["class", "staticClass", "style", "staticStyle", "attrs"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function hump2Underline(s) {
  return s.replace(/([A-Z])/g, "-$1").toLowerCase().replace("view-box", "viewBox");
}
function jsonToUnderline(obj) {
  if (obj instanceof Array) {
    obj.forEach(function (v) {
      jsonToUnderline(v);
    });
  } else if (obj instanceof Object) {
    Object.keys(obj).forEach(function (key) {
      var newKey = hump2Underline(key);
      if (newKey !== key) {
        obj[newKey] = obj[key];
        delete obj[key];
      }
      jsonToUnderline(obj[newKey]);
    });
  }
}
var IconBase = Vue.extend({
  functional: true,
  props: {
    icon: {
      type: Object
    },
    id: {
      type: String,
      "default": ""
    }
  },
  render: function render(createElement, context) {
    var _context$props = context.props,
      icon = _context$props.icon,
      id = _context$props.id,
      userProps = _objectWithoutProperties(_context$props, _excluded);
    var _context$data$props = context.data.props,
      staticClass = _context$data$props.staticClass,
      style = _context$data$props.style,
      _ = _context$data$props.icon,
      __ = _context$data$props.id,
      onClick = _context$data$props.onClick,
      otherProps = _objectWithoutProperties(_context$data$props, _excluded2);
    var _context$data = context.data,
      customClassName = _context$data["class"],
      customStaticClassName = _context$data.staticClass,
      customStyle = _context$data.style,
      customStaticStyle = _context$data.staticStyle,
      attrs = _context$data.attrs,
      otherBinds = _objectWithoutProperties(_context$data, _excluded3);
    var domProps = otherBinds.domProps,
      on = otherBinds.on,
      nativeOn = otherBinds.nativeOn,
      directives = otherBinds.directives,
      scopedSlots = otherBinds.scopedSlots,
      slot = otherBinds.slot,
      key = otherBinds.key,
      ref = otherBinds.ref,
      refInFor = otherBinds.refInFor;
    var finalCls = classNames("t-icon", "t-icon-".concat(id), staticClass, customClassName, customStaticClassName);
    var finalStyle = _objectSpread(_objectSpread(_objectSpread({
      fill: "none"
    }, style), customStyle), customStaticStyle);
    jsonToUnderline(icon);
    var _click = onClick || (on === null || on === void 0 ? void 0 : on.click);
    return renderFn(createElement, icon, {
      "class": void 0,
      staticClass: finalCls,
      props: _objectSpread(_objectSpread({}, userProps), otherProps),
      attrs: attrs,
      style: finalStyle,
      on: _objectSpread(_objectSpread({}, on), {}, {
        click: function click(e) {
          return _click === null || _click === void 0 ? void 0 : _click({
            e: e
          });
        }
      }, nativeOn),
      directives: directives,
      scopedSlots: scopedSlots,
      slot: slot,
      key: key,
      ref: ref,
      refInFor: refInFor,
      domProps: domProps
    });
  }
});

export default IconBase;
//# sourceMappingURL=icon.js.map
